import { useContext } from 'react';

import { SbWrapContext } from 'app/providers/SendBirdWrapProvider';

export const useSendBirdWrap = () => useContext(SbWrapContext);
